import $ from 'jquery';
import 'select2';
import {gestoreModuli} from "./class.gestoremoduli";
import {palette} from "./class.palette";
import {sceneManager} from "./class.scenemanager";
import list from './moduleList';
import {textures} from './textures';

require('spectrum-colorpicker');

class Ui {

    constructor() {
        this.createWrapper();
        this.createUiControls('1808');
        this.createColorPicker();
        /*window.addEventListener('click', () => this.selectFoot(event) );*/
        /*$('[data-piede]').on('select2:open', () => this.selectFoot(event));
        $('[data-piede]').on('select2:close', () => this.deselectFoot());*/
        $('canvas').on('click', () => this.closeAllSelect2());
        $('body')
            .on('click', '#toggleOutline', () => gestoreModuli.toggleOutline())
            .on('click', '#toggleClickMode', () => sceneManager.toggleClickMode())
            .on('change', '#toggleFeet', () => gestoreModuli.toggleFeet());
        /*$('#save').on('click', () => sceneManager.takeScreenshot(sceneManager._engine, sceneManager._screenshotCamera   ));*/
    }

    static getCurrentColor() {
        return this._selectedColor;
    }

    createWrapper() {
        //WRAPPER
        this._wrapper = document.createElement('div');
        this._wrapper.setAttribute('id', 'ui');
        this._wrapper.setAttribute('data-toggler', '.is-visible');
        document.body.appendChild(this._wrapper);
        const title = document.createElement('div');
        title.innerHTML = this.generateModeTitle();
        document.body.appendChild(title);
    }

    createColorPicker() {
        // COLORPICKER
        const colorPickerWrapper = document.createElement('div');
        colorPickerWrapper.setAttribute('id', 'colorPickerWrapper');
        colorPickerWrapper.classList.add('cell');
        document.getElementById('colorPickerWrapper').prepend(colorPickerWrapper);
        const markup = `
             <div class="color-picker">
                    <input type="text" id="custom"> <span id="colorName">Bianco Traffico</span>
            </div>
        `;
        colorPickerWrapper.innerHTML = markup;
        this._colorPicker = $('#custom').spectrum({
            showPaletteOnly: true,
            showPalette: true,
            color: palette._palette[0][0],
            palette: palette._palette,
        });
        this._colorPicker.on('change.spectrum move.spectrum', () => {
            const spectrum = this._colorPicker.spectrum('get');
            this._selectedColor = spectrum.toRgb();
            document.getElementById('colorName').innerHTML = palette.rgbToName(spectrum.toRgb());
        });
        const spectrum = this._colorPicker.spectrum('get');
        this._selectedColor = spectrum.toRgb();
    }

    createUiControls(mobile) {
        const feet = this.splitFeetArray();

        const markup = `
            <button id="toggleMenu" class="hide-for-medium hamburger hamburger--collapse" type="button" data-toggle="ui toggleMenu" data-toggler=".is-active">
                <span class="hamburger-box">
                <span class="hamburger-inner"></span>
                </span>
            </button>
            <div class="grid-x grid-padding-x grid-padding-y">
                <div class="cell">
                    <ul id="uiAccordion" class="accordion" data-accordion data-allow-all-closed="true">
                        ${this.generateUiAppModeSection()}
                        ${this.generateUiModularElementsSection()}
                        ${this.generateUiBasementsSection()}
                        ${this.generateUiFeetSection(feet)}
                        ${this.generateUiMaterialsSection()}
                        ${this.generateUiOptionsSection()}
                        ${this.generateUiSaveSection()}
                    </ul>
                </div>
            </div>`;

        const uiControls = document.createElement('div');
        uiControls.setAttribute('id', 'uiControls');
        this._wrapper.appendChild(uiControls);
        uiControls.innerHTML = markup;
        $('[data-mobile="' + gestoreModuli._codice + '"]').addClass('active');

        $('#cambioMobile').select2({
            templateSelection: this.formatImage,
            templateResult: this.formatImage,
            minimumResultsForSearch: -1
        });

        $('[data-mobile]').on('click', (event) => {
            const baseType = $(event.currentTarget).data('mobile');
            gestoreModuli.changeMobile(baseType);
            $(document).foundation();
        });

        $('[data-mode]').on('click', (event) => {
            const mode = $(event.currentTarget).data('mode');
            const title = $(event.currentTarget).data('mode-title');
            const mobileAttivo = gestoreModuli._codice;
            sceneManager.changeAppMode(mode);
            sceneManager.changeAppTitle(sceneManager.appModeNames[title]);
            gestoreModuli.changeMobile(mobileAttivo);
            $('#modeTitle').html(sceneManager.appModeTitle);
            $(document).foundation();
        });

        $('#toggleTop').on('click', function () {
            gestoreModuli.toggleTop();
            if (sceneManager._topVisible) {
                $(this).html('Nascondi Top / Hide Top')
            } else {
                $(this).html('Mostra Top / Show Top')
            }
        });

        $('[data-download]').on('click', function () {
            const date = new Date();
            const dateStr = 'attitude_' + date.getDate() + '_' + date.getMonth() + '_' + date.getFullYear() + '_' + date.getTime() + '.png';
            const screenshot = BABYLON.Tools.CreateScreenshotUsingRenderTarget(sceneManager._engine, sceneManager._camera, {precision: 2}, null, 'image/png', 2, true, dateStr);
        });


        /* $('#cambioMobile').on('select2:select', function (e) {
             const baseType = $(e.params.data.element).data('mobile');
             gestoreModuli.changeMobile(baseType);
             $(document).foundation();
         });*/

        $('.cambioPiede').select2({
            templateSelection: this.formatImage,
            templateResult: this.formatImage
        });

        $('.cambioTexture').select2({
            templateSelection: this.formatTexture,
            templateResult: this.formatTexture
        });

        $('.cambioPiede').on('select2:select', function (e) {
            const footType = $(e.params.data.element).data('mesh');
            const footIndex = $(e.params.data.element).parent().data('piede');

            gestoreModuli.changeFoot(footType, footIndex);
        });

        $('.cambioTexture').on('select2:select', function (e) {
            const texture = $(e.params.data.element).data('texture');
            const textureUrl = 'dist/assets/imports/textures/' + texture + '.jpg';

            gestoreModuli.updateBodyTexture(textureUrl);
        });

        /*$('#cambioBase').select2({
            templateSelection: this.formatImage,
            templateResult: this.formatImage
        });*/

        $('[data-base]').on('click', (e) => {
            const baseType = $(e.target).data('base');
            gestoreModuli.changeBase(baseType);
            if (baseType == 1) {
                this.showHideFeetCheckbox(true)
                $('#piediWrapper').fadeIn();
            } else if (baseType == 2) {
                $('#piediWrapper').fadeOut();
            } else {
                $('#piediWrapper').fadeIn();
                this.showHideFeetCheckbox(false)
            }

            console.log(gestoreModuli.extractData())
        });

        $('#save').on('click', () => gestoreModuli.extractData());
    }

    showHideFeetCheckbox(bool) {
        if (bool) {
            $('#hideFeet').fadeIn()
        } else {
            $('#hideFeet').fadeOut()
            $('#toggleFeet').prop("checked", false);
            gestoreModuli.showFeet()
        }
    }

    returnSelectedColor3() {
        const color = this._selectedColor;

        return new BABYLON.Color3((color._r / 255), (color._g / 255), (color._b / 255));
    }

    formatImage(image) {
        if (!image.id) {
            return image.text;
        }
        let baseUrl = "dist/assets/img/icons/piedi/";

        return $(
            '<span><img src="' + baseUrl + '/' + image.element.value + '.jpg" class="img-flag" /><span class="text">' + image.text + '</span></span>'
        );
    };

    formatTexture(image) {
        if (!image.id) {
            return image.text;
        }
        let baseUrl = "dist/assets/imports/textures/";

        return $(
            '<span><img src="' + baseUrl + 'thumb/' + image.element.value + '.jpg" class="img-flag" /><span class="text">' + image.text + '</span></span>'
        );
    };


    selectFoot(event) {
        const footIndex = $(event.target).closest('.cell').find('[data-piede]').data('piede');

        gestoreModuli.selectFoot(footIndex);
    }

    deselectFoot() {
        gestoreModuli.deselectFoot();
    }

    closeAllSelect2() {
        $('.cambioPiede').select2('close');
        $('#cambioBase').select2('close');
        $('#cambioMobile').select2('close');
    }

    splitFeetArray() {
        let feet = {
            front: [],
            back: []
        };
        if (gestoreModuli._piedi.length == 4) {
            gestoreModuli._piedi.map((piede, index) => {
                if (index < 2) {
                    feet.front.push(piede);
                } else {
                    feet.back.push(piede);
                }
            });
        } else if (gestoreModuli._piedi.length == 7) {
            gestoreModuli._piedi.map((piede, index) => {
                if (index < 4) {
                    feet.front.push(piede);
                } else {
                    feet.back.push(piede);
                }
            });
        } else {
            gestoreModuli._piedi.map((piede, index) => {
                if (index < 3) {
                    feet.front.push(piede);
                } else {
                    feet.back.push(piede);
                }
            });
        }

        return feet;
    }

    reloadUi(type) {
        document.getElementById('ui').innerText = '';
        this.createUiControls(type.toString());
        this.createColorPicker();
        this._wrapper.classList.remove('is-visible');
    }

    generateUiAppModeSection() {
        return `<li class="accordion-item is-active" data-accordion-item>
            <a href="#" class="accordion-title">0 - Scegli modalità / Select mode</a>
            <div class="accordion-content" data-tab-content>
            <div class="grid-x small-up-6">
                    <button data-mode="0" data-mode-title="5" class="button large expanded">Frontali malta laccata<br> <small><i>Cement lacquered fronts</i></small></button>
                </div>
                <div class="grid-x small-up-6">
                    <button data-mode="1" data-mode-title="0" class="button large expanded">Frontali malta stampata Geometrica<br> <small><i>Cement fronts with geometric printings</i></small></button>
                </div>
                <div class="grid-x small-up-6">
                    <button data-mode="2" data-mode-title="1" class="button large expanded">Frontali malta stampata<br> <small><i>Printed cement fronts</i></small></button>
                </div>
                <div class="grid-x small-up-6">
                    <button data-mode="2" data-mode-title="4" class="button large expanded">Frontali lucidi stampati<br> <small><i>Extra-glossy cement fronts</i></small></button>
                </div>
                <div class="grid-x small-up-6">
                    <button data-mode="3" data-mode-title="2" class="button large expanded">Frontali velluto stampati <br> <small><i>Printed velvet fronts</i></small></button>
                </div>
                <div class="grid-x small-up-6">
                    <button data-mode="4" data-mode-title="3" class="button large expanded">Frontali tecnofiber stampati <br> <small><i>Tecnofiber printed fronts</i></small></button>
                </div>
            </div>
        </li>`
    }

    generateUiModularElementsSection() {
        return `<li class="accordion-item" data-accordion-item>
            <a href="#" class="accordion-title">1 - Elementi Modulari / Modular Elements</a>
            <div class="accordion-content" data-tab-content>
                <div class="grid-x small-up-4 large-up-5">
                    ${list.moduli.map((modulo) => `
                            ${sceneManager.appMode !== 1 ? `
                            <div class="cell"><img data-mobile="${modulo[0].split('-')[1]}" class="thumbnail" src="dist/assets/img/icons/mobili/${modulo[0]}.jpg" alt=""><p>${modulo[0]}</p></div>
                            ` : modulo[1] ? `
                            <div class="cell"><img data-mobile="${modulo[0].split('-')[1]}" class="thumbnail" src="dist/assets/img/icons/mobili/${modulo[0]}.jpg" alt=""><p>${modulo[0]}</p></div>
                            ` : ''}
                        `).join('')}
                    </div>
                </div>
            </li>`
    }

    generateUiBasementsSection() {
        return `<li class="accordion-item" data-accordion-item>
            <a href="#" class="accordion-title">2 - Basamenti / Pedestals</a>
            <div class="accordion-content" data-tab-content> 
                <div class="grid-x small-up-3">
                    <div class="cell">
                        <img data-base="0" class="thumbnail" src="dist/assets/img/icons/basi/baseB.jpg" alt="">
                        <p>BB</p>
                    </div>
                    <div class="cell">
                        <img data-base="1" class="thumbnail" src="dist/assets/img/icons/basi/baseA.jpg" alt="">
                    <p>CC</p>
                    </div>
                    <div class="cell">
                        <img data-base="2" class="thumbnail" src="dist/assets/img/icons/basi/baseC.jpg" alt="">
                        <p>DD</p>
                    </div>
                </div>
            </div>
        </li>`
    }

    generateUiFeetSection(feet) {
        return `<li id="piediWrapper" class="accordion-item" data-accordion-item>
            <a href="#" class="accordion-title">3- Piedi torniti / Lathed feet</a>
            <div class="accordion-content" data-tab-content>
                <div class="piediContainer${feet.front.length == 3 ? ' triple' : ' double'}">
                    <p class="text-left">Anteriori / Front</p>
                    ${Object.keys(feet.front).map((piede, key) => `
                        <select data-piede="${key}" name="" class="cambioPiede">
                            <option data-mesh="0" value="ft-1">FT-1</option>
                            <option data-mesh="1" value="ft-2">FT-2</option>
                            <option data-mesh="2" value="ft-3">FT-3</option>
                            <option data-mesh="4" value="ft-4">FT-4</option>
                            <option data-mesh="3" value="ft-5">FT-5</option>
                            <option data-mesh="5" value="ft-6">FT-6</option>
                        </select>
                    `).join('')}
                    <p class="text-left">Posteriori / Back</p>
                    ${Object.keys(feet.back).map((piede, key) => `
                        <select data-piede="${key + feet.front.length}" name="" class="cambioPiede">
                            <option data-mesh="0" value="ft-1">FT-1</option>
                            <option data-mesh="1" value="ft-2">FT-2</option>
                            <option data-mesh="2" value="ft-3">FT-3</option>
                            <option data-mesh="4" value="ft-4">FT-4</option>
                            <option data-mesh="3" value="ft-5">FT-5</option>
                            <option data-mesh="5" value="ft-6">FT-6</option>
                        </select>
                    `).join('')}
                    <div style="display: none" id="hideFeet">
                        <div style="display: flex; align-items: center">
                            <input id="toggleFeet" type="checkbox" style="margin-right: 10px; margin-bottom: 0;">
                            <p style="margin-bottom: 0;">Nascondi piedi</p>
                        </div>
                    </div>
                </div>
            </div>
        </li>`
    }

    generateUiMaterialsSection() {
        switch (sceneManager.appMode) {
            case 0:
                return `<li class="accordion-item" data-accordion-item>
                    <a href="#" class="accordion-title">4 - Laccature Opache / Matte Lacquers</a>
                    <div class="accordion-content" data-tab-content>
                        <div id="colorPickerWrapper" class="grid-x grid-padding-x grid-padding-y"></div>
                    </div>
                </li>`;
            case 1:
                return `<li class="accordion-item" data-accordion-item>
                    <a href="#" class="accordion-title">4 - Laccature Opache / Matte Lacquers</a>
                    <div class="accordion-content" data-tab-content>
                        <div id="colorPickerWrapper" class="grid-x grid-padding-x grid-padding-y"></div>
                    </div>
                </li>`;
            default:
                return `<li class="accordion-item" data-accordion-item>
                    <a href="#" class="accordion-title">4 - Texture e laccature / Textures and Lacquerings</a>
                    <div class="accordion-content" data-tab-content>
                        <div id="colorPickerWrapper" class="grid-x grid-padding-x grid-padding-y"></div>
                        <div id="textureWrapper" class="grid-x grid-padding-x grid-padding-y">
                            <div class="cell">
                                <select data-texture="EP1A" name="" class="cambioTexture">
                                    <optgroup label="Eros e Psiche">
                                        ${textures["eros-e-psiche"].map(texture => `
                                        <option data-texture="eros-e-psiche/${texture}" value="eros-e-psiche/${texture}">${texture}</option>
                                        `).join('')}
                                    </optgroup> 
                                    <optgroup label="Rx Nuance">                                
                                        ${textures["rx-nuance"].map(texture => `
                                        <option data-texture="rx-nuance/${texture}" value="rx-nuance/${texture}">${texture}</option>
                                        `).join('')}
                                    </optgroup>
                                    <optgroup label="Techno Folk">                                
                                        ${textures["techno-folk"].map(texture => `
                                        <option data-texture="techno-folk/${texture}" value="techno-folk/${texture}">${texture}</option>
                                        `).join('')}
                                    </optgroup>
                                </select>
                            </div>
                        </div>
                    </div>
                </li>`;
        }
    }

    generateUiOptionsSection() {
        return `<li class="accordion-item" data-accordion-item>
            <a href="#" class="accordion-title">5 - Opzioni / Options</a>
            <div class="accordion-content" data-tab-content>
                ${gestoreModuli._top ? `
                <div class="cell">
                    <button id="toggleTop" class="button">Mostra Top / Show Top</button>
                </div>
                ` : `
                <div class="cell">
                    <button class="button" disabled>Top non disponibile / Top not available</button>
                </div>
                `}
                ${sceneManager.appMode === 1 ? `
                <div class="cell">
                    <button id="toggleClickMode" class="button">Anta Intera / Full Front</button>
                </div>
                <div class="cell">
                    <button id="toggleOutline" class="button">${sceneManager._showWireframe ? 'Nascondi Griglia / Hide Grid' : 'Mostra Griglia / Show Grid'}</button>
                </div>
                ` : ''}
            </div>
        </li>`
    }

    generateUiSaveSection() {
        return `<li class="accordion-item" data-accordion-item>
            <a href="#" class="accordion-title">6 - Salva / Save</a>
            <div class="accordion-content" data-tab-content>
                <button data-download class="button expanded" id="downloadScreenshot">Salva immagine / Save image</button>
                <button data-open="sendEmail" class="button expanded" id="save">Richiedi Informazioni / Ask for info</button>
            </div>
        </li>`
    }

    generateModeTitle() {
        return `<div id="modeTitle">Frontali malta laccata / Cement lacquered fronts</div>`
    }
}

export const ui = new Ui();
export default ui;
